enum CommitteeType {
  unknown = 0,
  committee = 1,
  normal = 2,
}

export { CommitteeType }
